module.exports = __webpack_public_path__ + "static/img/s47.4f04e6de.png";